module.exports = __webpack_public_path__ + "static/media/ic_baseline-phone-iphone.643ec33e.svg";